import React from 'react';

const LineLoader = () => (
    <div className="line-loader"></div>
);

export default LineLoader;
